// Reducer Dunning

import {
  GET_DUNNING_LIST,
  GET_DUNNING_LIST_FAILURE,
  GET_DUNNING_LIST_SUCCESS,
  GET_DUNNING_ACTION_LIST,
  GET_DUNNING_ACTION_LIST_SUCCESS,
  GET_DUNNING_ACTION_LIST_FAILURE,
  CREATE_DUNNING_EVENT,
  CREATE_DUNNING_EVENT_SUCCESS,
  CREATE_DUNNING_EVENT_FAILURE,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_FAILURE,
  GET_DUNNING_SINGLE_EVENT,
  GET_DUNNING_SINGLE_EVENT_SUCCESS,
  GET_DUNNING_SINGLE_EVENT_FAILURE,
  UPDATE_DUNNING_EVENT,
  UPDATE_DUNNING_EVENT_SUCCESS,
  UPDATE_DUNNING_EVENT_FAILURE,
  DELETE_DUNNING_EVENT,
  DELETE_DUNNING_EVENT_SUCCESS,
  DELETE_DUNNING_EVENT_FAILURE,
  ADD_NEW_DUNNING_EVENT_ACTION,
  ADD_NEW_DUNNING_EVENT_ACTION_SUCCESS,
  ADD_NEW_DUNNING_EVENT_ACTION_FAILURE,
  UPDATE_DUNNING_EVENT_ACTION,
  UPDATE_DUNNING_EVENT_ACTION_SUCCESS,
  UPDATE_DUNNING_EVENT_ACTION_FAILURE,
  DELETE_DUNNING_EVENT_ACTION,
  DELETE_DUNNING_EVENT_ACTION_SUCCESS,
  DELETE_DUNNING_EVENT_ACTION_FAILURE,
  GET_DUNNING_LOCK_TYPE_LIST,
  GET_DUNNING_LOCK_TYPE_LIST_SUCCESS,
  GET_DUNNING_LOCK_TYPE_LIST_FAILURE,
  GET_DUNNING_LOCK_TYPE_DATA,
  GET_DUNNING_LOCK_TYPE_DATA_SUCCESS,
  GET_DUNNING_LOCK_TYPE_DATA_FAILURE,
  CREATE_DUNNING_LOCK_TYPE,
  CREATE_DUNNING_LOCK_TYPE_SUCCESS,
  CREATE_DUNNING_LOCK_TYPE_FAILURE,
  UPDATE_DUNNING_LOCK_TYPE,
  UPDATE_DUNNING_LOCK_TYPE_SUCCESS,
  UPDATE_DUNNING_LOCK_TYPE_FAILURE,
  DELETE_DUNNING_LOCK_TYPE,
  DELETE_DUNNING_LOCK_TYPE_SUCCESS,
  DELETE_DUNNING_LOCK_TYPE_FAILURE,
  GET_DUNNING_LOCK_LIST,
  GET_DUNNING_LOCK_LIST_SUCCESS,
  GET_DUNNING_LOCK_LIST_FAILURE,
  GET_DUNNING_LOCK_DATA,
  GET_DUNNING_LOCK_DATA_SUCCESS,
  GET_DUNNING_LOCK_DATA_FAILURE,
  CREATE_DUNNING_LOCK,
  CREATE_DUNNING_LOCK_SUCCESS,
  CREATE_DUNNING_LOCK_FAILURE,
  UPDATE_DUNNING_LOCK,
  UPDATE_DUNNING_LOCK_SUCCESS,
  UPDATE_DUNNING_LOCK_FAILURE,
  DELETE_DUNNING_LOCK,
  DELETE_DUNNING_LOCK_SUCCESS,
  DELETE_DUNNING_LOCK_FAILURE,
  GET_DUNNING_PROFILE_LIST,
  GET_DUNNING_PROFILE_LIST_SUCCESS,
  GET_DUNNING_PROFILE_LIST_FAILURE,
  GET_DUNNING_PROFILE_DATA,
  GET_DUNNING_PROFILE_DATA_SUCCESS,
  GET_DUNNING_PROFILE_DATA_FAILURE,
  CREATE_DUNNING_PROFILE,
  CREATE_DUNNING_PROFILE_SUCCESS,
  CREATE_DUNNING_PROFILE_FAILURE,
  UPDATE_DUNNING_PROFILE,
  UPDATE_DUNNING_PROFILE_SUCCESS,
  UPDATE_DUNNING_PROFILE_FAILURE,
  DELETE_DUNNING_PROFILE,
  DELETE_DUNNING_PROFILE_SUCCESS,
  DELETE_DUNNING_PROFILE_FAILURE,
  GET_DUNNING_PROFILE_STEP_LIST,
  GET_DUNNING_PROFILE_STEP_LIST_SUCCESS,
  GET_DUNNING_PROFILE_STEP_LIST_FAILURE,
  GET_DUNNING_PROFILE_STEP_DATA,
  GET_DUNNING_PROFILE_STEP_DATA_SUCCESS,
  GET_DUNNING_PROFILE_STEP_DATA_FAILURE,
  CREATE_DUNNING_PROFILE_STEP,
  CREATE_DUNNING_PROFILE_STEP_SUCCESS,
  CREATE_DUNNING_PROFILE_STEP_FAILURE,
  UPDATE_DUNNING_PROFILE_STEP,
  UPDATE_DUNNING_PROFILE_STEP_SUCCESS,
  UPDATE_DUNNING_PROFILE_STEP_FAILURE,
  DELETE_DUNNING_PROFILE_STEP,
  DELETE_DUNNING_PROFILE_STEP_SUCCESS,
  DELETE_DUNNING_PROFILE_STEP_FAILURE,
} from "./actionType";

const initialState = {
  dunningList: [],
  loadingList: false,
  errorList: null,
  dunningActionList: [],
  loadingActionList: false,
  errorActionList: null,
  dunningEventSuccessResponse: [],
  loadingEvent: false,
  errorEvent: null,
  singleCustomerDunningEventList: [],
  loadingSingleCustomerDunningEventList: false,
  errorSingleCustomerDunningEventList: null,
  dunningSingleEvent: [],
  loadingSingleEvent: false,
  errorSingleEvent: null,
  dunningUpdateEvent: [],
  loadingUpdateEvent: false,
  dunningDeleteEvent: [],
  loadingDeleteEvent: false,
  errorUpdateEvent: null,
  addDunningEventActionSuccess: [],
  loadingAddDunningEventAction: false,
  errorAddDunningEventAction: null,
  updateDunningEventActionSuccess: [],
  loadingUpdateDunningEventAction: false,
  errorUpdateDunningEventAction: null,
  deleteDunningEventActionSuccess: [],
  loadingDeleteDunningEventAction: false,
  errorDeleteDunningEventAction: null,

  //dunning lock type
  dunningLockTypeList: [],
  loadingDunningLockTypeList: false,
  errorDunningLockTypeList: null,
  getDunningLockTypeDataResponse: [],
  loadingGetDunningLockTypeData: false,
  errorGetDunningLockTypeData: null,
  createDunningLockTypeResponse: [],
  loadingCreateDunningLockType: false,
  errorCreateDunningLockType: null,
  updateDunningLockTypeResponse: [],
  loadingUpdateDunningLockType: false,
  errorUpdateDunningLockType: null,
  deleteDunningLockTypeResponse: [],
  loadingDeleteDunningLockType: false,
  errorDeleteDunningLockType: null,

  //dunning lock
  dunningLockList: [],
  loadingDunningLockList: false,
  errorDunningLockList: null,
  getDunningLockDataResponse: [],
  loadingGetDunningLockData: false,
  errorGetDunningLockData: null,
  createDunningLockResponse: [],
  loadingCreateDunningLock: false,
  errorCreateDunningLock: null,
  updateDunningLockResponse: [],
  loadingUpdateDunningLock: false,
  errorUpdateDunningLock: null,
  deleteDunningLockResponse: [],
  loadingDeleteDunningLock: false,
  errorDeleteDunningLock: null,

  //dunning profile
  dunningProfileList: [],
  loadingDunningProfileList: false,
  errorDunningProfileList: null,
  getDunningProfileDataResponse: [],
  loadingGetDunningProfileData: false,
  errorGetDunningProfileData: null,
  createDunningProfileResponse: [],
  loadingCreateDunningProfile: false,
  errorCreateDunningProfile: null,
  updateDunningProfileResponse: [],
  loadingUpdateDunningProfile: false,
  errorUpdateDunningProfile: null,
  deleteDunningProfileResponse: [],
  loadingDeleteDunningProfile: false,
  errorDeleteDunningProfile: null,

  //dunning profile step
  dunningProfileStepList: [],
  loadingDunningProfileStepList: false,
  errorDunningProfileStepList: null,
  getDunningProfileStepDataResponse: [],
  loadingGetDunningProfileStepData: false,
  errorGetDunningProfileStepData: null,
  createDunningProfileStepResponse: [],
  loadingCreateDunningProfileStep: false,
  errorCreateDunningProfileStep: null,
  updateDunningProfileStepResponse: [],
  loadingUpdateDunningProfileStep: false,
  errorUpdateDunningProfileStep: null,
  deleteDunningProfileStepResponse: [],
  loadingDeleteDunningProfileStep: false,
  errorDeleteDunningProfileStep: null,
};

export default function Dunning(state = initialState, action) {
  switch (action.type) {
    case GET_DUNNING_LIST:
      return {
        ...state,
        loadingList: true,
      };
    case GET_DUNNING_LIST_SUCCESS:
      return {
        ...state,
        loadingList: false,
        dunningList: action.payload,
      };
    case GET_DUNNING_LIST_FAILURE:
      return {
        ...state,
        loadingList: false,
        errorList: action.payload,
      };
    case GET_DUNNING_ACTION_LIST:
      return {
        ...state,
        loadingActionList: true,
      };
    case GET_DUNNING_ACTION_LIST_SUCCESS:
      return {
        ...state,
        loadingActionList: false,
        dunningActionList: action.payload,
      };
    case GET_DUNNING_ACTION_LIST_FAILURE:
      return {
        ...state,
        loadingActionList: false,
      };
    case CREATE_DUNNING_EVENT:
      return {
        ...state,
        loadingEvent: true,
      };
    case CREATE_DUNNING_EVENT_SUCCESS:
      return {
        ...state,
        loadingEvent: false,
        dunningEventSuccessResponse: action.payload,
      };
    case CREATE_DUNNING_EVENT_FAILURE:
      return {
        ...state,
        loadingEvent: false,
        errorEvent: action.payload,
      };
    case SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST:
      return {
        ...state,
        loadingSingleCustomerDunningEventList: true,
      };
    case SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_SUCCESS:
      return {
        ...state,
        loadingSingleCustomerDunningEventList: false,
        singleCustomerDunningEventList: action.payload,
      };
    case SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_FAILURE:
      return {
        ...state,
        loadingSingleCustomerDunningEventList: false,
        errorSingleCustomerDunningEventList: action.payload,
      };
    case GET_DUNNING_SINGLE_EVENT:
      return {
        ...state,
        loadingSingleEvent: true,
      };
    case GET_DUNNING_SINGLE_EVENT_SUCCESS:
      return {
        ...state,
        loadingSingleEvent: false,
        dunningSingleEvent: action.payload,
      };
    case GET_DUNNING_SINGLE_EVENT_FAILURE:
      return {
        ...state,
        loadingSingleEvent: false,
        errorSingleEvent: action.payload,
      };
    case UPDATE_DUNNING_EVENT:
      return {
        ...state,
        loadingUpdateEvent: true,
      };
    case UPDATE_DUNNING_EVENT_SUCCESS:
      return {
        ...state,
        loadingUpdateEvent: false,
        dunningUpdateEvent: action.payload,
      };
    case UPDATE_DUNNING_EVENT_FAILURE:
      return {
        ...state,
        loadingUpdateEvent: false,
        errorUpdateEvent: action.payload,
      };
    case DELETE_DUNNING_EVENT:
      return {
        ...state,
        loadingDeleteEvent: true,
      };
    case DELETE_DUNNING_EVENT_SUCCESS:
      return {
        ...state,
        loadingDeleteEvent: false,
        dunningDeleteEvent: action.payload,
      };
    case DELETE_DUNNING_EVENT_FAILURE:
      return {
        ...state,
        loadingDeleteEvent: false,
        errorDeleteEvent: action.payload,
      };

    case ADD_NEW_DUNNING_EVENT_ACTION:
      return {
        ...state,
        loadingAddDunningEventAction: true,
      };
    case ADD_NEW_DUNNING_EVENT_ACTION_SUCCESS:
      return {
        ...state,
        loadingAddDunningEventAction: false,
        addDunningEventActionSuccess: action.payload,
      };
    case ADD_NEW_DUNNING_EVENT_ACTION_FAILURE:
      return {
        ...state,
        loadingAddDunningEventAction: false,
        errorAddDunningEventAction: action.payload,
      };
    case UPDATE_DUNNING_EVENT_ACTION:
      return {
        ...state,
        loadingUpdateDunningEventAction: true,
      };
    case UPDATE_DUNNING_EVENT_ACTION_SUCCESS:
      return {
        ...state,
        loadingUpdateDunningEventAction: false,
        updateDunningEventActionSuccess: action.payload,
      };
    case UPDATE_DUNNING_EVENT_ACTION_FAILURE:
      return {
        ...state,
        loadingUpdateDunningEventAction: false,
        errorUpdateDunningEventAction: action.payload,
      };
    case DELETE_DUNNING_EVENT_ACTION:
      return {
        ...state,
        loadingDeleteDunningEventAction: true,
      };
    case DELETE_DUNNING_EVENT_ACTION_SUCCESS:
      return {
        ...state,
        loadingDeleteDunningEventAction: false,
        deleteDunningEventActionSuccess: action.payload,
      };
    case DELETE_DUNNING_EVENT_ACTION_FAILURE:
      return {
        ...state,
        loadingDeleteDunningEventAction: false,
        errorDeleteDunningEventAction: action.payload,
      };
    case GET_DUNNING_LOCK_TYPE_LIST:
      return {
        ...state,
        loadingDunningLockTypeList: true,
      };
    case GET_DUNNING_LOCK_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loadingDunningLockTypeList: false,
        dunningLockTypeList: action.payload,
      };
    case GET_DUNNING_LOCK_TYPE_LIST_FAILURE:
      return {
        ...state,
        loadingDunningLockTypeList: false,
        errorDunningLockTypeList: action.payload,
      };
    case GET_DUNNING_LOCK_TYPE_DATA:
      return {
        ...state,
        loadingGetDunningLockTypeData: true,
      };
    case GET_DUNNING_LOCK_TYPE_DATA_SUCCESS:
      return {
        ...state,
        loadingGetDunningLockTypeData: false,
        getDunningLockTypeDataResponse: action.payload,
      };
    case GET_DUNNING_LOCK_TYPE_DATA_FAILURE:
      return {
        ...state,
        loadingGetDunningLockTypeData: false,
        errorGetDunningLockTypeData: action.payload,
      };
    case CREATE_DUNNING_LOCK_TYPE:
      return {
        ...state,
        loadingCreateDunningLockType: true,
      };
    case CREATE_DUNNING_LOCK_TYPE_SUCCESS:
      return {
        ...state,
        loadingCreateDunningLockType: false,
        createDunningLockTypeResponse: action.payload,
      };
    case CREATE_DUNNING_LOCK_TYPE_FAILURE:
      return {
        ...state,
        loadingCreateDunningLockType: false,
        errorCreateDunningLockType: action.payload,
      };
    case UPDATE_DUNNING_LOCK_TYPE:
      return {
        ...state,
        loadingUpdateDunningLockType: true,
      };
    case UPDATE_DUNNING_LOCK_TYPE_SUCCESS:
      return {
        ...state,
        loadingUpdateDunningLockType: false,
        updateDunningLockTypeResponse: action.payload,
      };
    case UPDATE_DUNNING_LOCK_TYPE_FAILURE:
      return {
        ...state,
        loadingUpdateDunningLockType: false,
        errorUpdateDunningLockType: action.payload,
      };
    case DELETE_DUNNING_LOCK_TYPE:
      return {
        ...state,
        loadingDeleteDunningLockType: true,
      };
    case DELETE_DUNNING_LOCK_TYPE_SUCCESS:
      return {
        ...state,
        loadingDeleteDunningLockType: false,
        deleteDunningLockTypeResponse: action.payload,
      };
    case DELETE_DUNNING_LOCK_TYPE_FAILURE:
      return {
        ...state,
        loadingDeleteDunningLockType: false,
        errorDeleteDunningLockType: action.payload,
      };
    case GET_DUNNING_LOCK_LIST:
      return {
        ...state,
        loadingDunningLockList: true,
      };
    case GET_DUNNING_LOCK_LIST_SUCCESS:
      return {
        ...state,
        loadingDunningLockList: false,
        dunningLockList: action.payload,
      };
    case GET_DUNNING_LOCK_LIST_FAILURE:
      return {
        ...state,
        loadingDunningLockList: false,
        errorDunningLockList: action.payload,
      };
    case GET_DUNNING_LOCK_DATA:
      return {
        ...state,
        loadingGetDunningLockData: true,
      };
    case GET_DUNNING_LOCK_DATA_SUCCESS:
      return {
        ...state,
        loadingGetDunningLockData: false,
        getDunningLockDataResponse: action.payload,
      };
    case GET_DUNNING_LOCK_DATA_FAILURE:
      return {
        ...state,
        loadingGetDunningLockData: false,
        errorGetDunningLockData: action.payload,
      };
    case CREATE_DUNNING_LOCK:
      return {
        ...state,
        loadingCreateDunningLock: true,
      };
    case CREATE_DUNNING_LOCK_SUCCESS:
      return {
        ...state,
        loadingCreateDunningLock: false,
        createDunningLockResponse: action.payload,
      };
    case CREATE_DUNNING_LOCK_FAILURE:
      return {
        ...state,
        loadingCreateDunningLock: false,
        errorCreateDunningLock: action.payload,
      };
    case UPDATE_DUNNING_LOCK:
      return {
        ...state,
        loadingUpdateDunningLock: true,
      };
    case UPDATE_DUNNING_LOCK_SUCCESS:
      return {
        ...state,
        loadingUpdateDunningLock: false,
        updateDunningLockResponse: action.payload,
      };
    case UPDATE_DUNNING_LOCK_FAILURE:
      return {
        ...state,
        loadingUpdateDunningLock: false,
        errorUpdateDunningLock: action.payload,
      };
    case DELETE_DUNNING_LOCK:
      return {
        ...state,
        loadingDeleteDunningLock: true,
      };
    case DELETE_DUNNING_LOCK_SUCCESS:
      return {
        ...state,
        loadingDeleteDunningLock: false,
        deleteDunningLockResponse: action.payload,
      };
    case DELETE_DUNNING_LOCK_FAILURE:
      return {
        ...state,
        loadingDeleteDunningLock: false,
        errorDeleteDunningLock: action.payload,
      };
    case GET_DUNNING_PROFILE_LIST:
      return {
        ...state,
        loadingDunningProfileList: true,
      };
    case GET_DUNNING_PROFILE_LIST_SUCCESS:
      return {
        ...state,
        loadingDunningProfileList: false,
        dunningProfileList: action.payload,
      };
    case GET_DUNNING_PROFILE_LIST_FAILURE:
      return {
        ...state,
        loadingDunningProfileList: false,
        errorDunningProfileList: action.payload,
      };
    case GET_DUNNING_PROFILE_DATA:
      return {
        ...state,
        loadingGetDunningProfileData: true,
      };
    case GET_DUNNING_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        loadingGetDunningProfileData: false,
        getDunningProfileDataResponse: action.payload,
      };
    case GET_DUNNING_PROFILE_DATA_FAILURE:
      return {
        ...state,
        loadingGetDunningProfileData: false,
        errorGetDunningProfileData: action.payload,
      };
    case CREATE_DUNNING_PROFILE:
      return {
        ...state,
        loadingCreateDunningProfile: true,
      };
    case CREATE_DUNNING_PROFILE_SUCCESS:
      return {
        ...state,
        loadingCreateDunningProfile: false,
        createDunningProfileResponse: action.payload,
      };
    case CREATE_DUNNING_PROFILE_FAILURE:
      return {
        ...state,
        loadingCreateDunningProfile: false,
        errorCreateDunningProfile: action.payload,
      };
    case UPDATE_DUNNING_PROFILE:
      return {
        ...state,
        loadingUpdateDunningProfile: true,
      };
    case UPDATE_DUNNING_PROFILE_SUCCESS:
      return {
        ...state,
        loadingUpdateDunningProfile: false,
        updateDunningProfileResponse: action.payload,
      };
    case UPDATE_DUNNING_PROFILE_FAILURE:
      return {
        ...state,
        loadingUpdateDunningProfile: false,
        errorUpdateDunningProfile: action.payload,
      };
    case DELETE_DUNNING_PROFILE:
      return {
        ...state,
        loadingDeleteDunningProfile: true,
      };
    case DELETE_DUNNING_PROFILE_SUCCESS:
      return {
        ...state,
        loadingDeleteDunningProfile: false,
        deleteDunningProfileResponse: action.payload,
      };
    case DELETE_DUNNING_PROFILE_FAILURE:
      return {
        ...state,
        loadingDeleteDunningProfile: false,
        errorDeleteDunningProfile: action.payload,
      };
    case GET_DUNNING_PROFILE_STEP_LIST:
      return {
        ...state,
        loadingDunningProfileStepList: true,
      };
    case GET_DUNNING_PROFILE_STEP_LIST_SUCCESS:
      return {
        ...state,
        loadingDunningProfileStepList: false,
        dunningProfileStepList: action.payload,
      };
    case GET_DUNNING_PROFILE_STEP_LIST_FAILURE:
      return {
        ...state,
        loadingDunningProfileStepList: false,
        errorDunningProfileStepList: action.payload,
      };
    case GET_DUNNING_PROFILE_STEP_DATA:
      return {
        ...state,
        loadingGetDunningProfileStepData: true,
      };
    case GET_DUNNING_PROFILE_STEP_DATA_SUCCESS:
      return {
        ...state,
        loadingGetDunningProfileStepData: false,
        getDunningProfileStepDataResponse: action.payload,
      };
    case GET_DUNNING_PROFILE_STEP_DATA_FAILURE:
      return {
        ...state,
        loadingGetDunningProfileStepData: false,
        errorGetDunningProfileStepData: action.payload,
      };
    case CREATE_DUNNING_PROFILE_STEP:
      return {
        ...state,
        loadingCreateDunningProfileStep: true,
      };
    case CREATE_DUNNING_PROFILE_STEP_SUCCESS:
      return {
        ...state,
        loadingCreateDunningProfileStep: false,
        createDunningProfileStepResponse: action.payload,
      };
    case CREATE_DUNNING_PROFILE_STEP_FAILURE:
      return {
        ...state,
        loadingCreateDunningProfileStep: false,
        errorCreateDunningProfileStep: action.payload,
      };
    case UPDATE_DUNNING_PROFILE_STEP:
      return {
        ...state,
        loadingUpdateDunningProfileStep: true,
      };
    case UPDATE_DUNNING_PROFILE_STEP_SUCCESS:
      return {
        ...state,
        loadingUpdateDunningProfileStep: false,
        updateDunningProfileStepResponse: action.payload,
      };
    case UPDATE_DUNNING_PROFILE_STEP_FAILURE:
      return {
        ...state,
        loadingUpdateDunningProfileStep: false,
        errorUpdateDunningProfileStep: action.payload,
      };
    case DELETE_DUNNING_PROFILE_STEP:
      return {
        ...state,
        loadingDeleteDunningProfileStep: true,
      };
    case DELETE_DUNNING_PROFILE_STEP_SUCCESS:
      return {
        ...state,
        loadingDeleteDunningProfileStep: false,
        deleteDunningProfileStepResponse: action.payload,
      };
    case DELETE_DUNNING_PROFILE_STEP_FAILURE:
      return {
        ...state,
        loadingDeleteDunningProfileStep: false,
        errorDeleteDunningProfileStep: action.payload,
      };

    default:
      return state;
  }
}
